"use client";
import { motion } from "framer-motion";
import logo from "@/assets/fresh0meat_logo.png";
import { Suspense } from "react";
import LazyImage from "@/components/LazyImage";

const RefundPolicyContent = () => {
    return (
        <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            className="min-h-screen bg-card pb-24"
        >
            <div className="container max-w-3xl mx-auto px-6 py-10 space-y-8">
                {/* Logo + Heading */}
                <div className="flex flex-col items-center gap-3 py-4 border-b border-border">
                    <LazyImage src={logo.src} alt="Fresh O Meat Logo" width={200} height={60} className="h-12 w-auto object-contain" />
                    <h1 className="text-3xl font-extrabold text-foreground text-center mt-4">
                        Refund Policy
                    </h1>
                    <p className="text-muted-foreground text-sm">Last updated: March 10, 2026</p>
                </div>

                {/* Body */}
                <div className="space-y-6 text-foreground/80 leading-relaxed">
                    <section className="space-y-3">
                        <h2 className="text-xl font-bold text-foreground">1. Refund Eligibility</h2>
                        <p>
                            Due to the perishable nature of our products, refunds are only issued under specific circumstances:
                        </p>
                        <ul className="list-disc pl-6 space-y-2">
                            <li>The product delivered is significantly different from what was ordered.</li>
                            <li>The product delivered is damaged or spoiled at the time of delivery.</li>
                            <li>The order was not delivered within a reasonable timeframe and you choose to cancel.</li>
                        </ul>
                    </section>

                    <section className="space-y-3">
                        <h2 className="text-xl font-bold text-foreground">2. Reporting Issues</h2>
                        <p>
                            Any issues with your order must be reported within 2 hours of delivery. Please provide photographic evidence of the issue when contacting us.
                        </p>
                    </section>

                    <section className="space-y-3">
                        <h2 className="text-xl font-bold text-foreground">3. Processing Refunds</h2>
                        <p>
                            Once your refund request is approved, the amount will be credited back to your original payment method within 5-7 business days.
                        </p>
                    </section>

                    <section className="space-y-3">
                        <h2 className="text-xl font-bold text-foreground">4. Cancellations</h2>
                        <p>
                            Orders can be cancelled only if they have not yet been processed for delivery. Once an order is processed or out for delivery, it cannot be cancelled.
                        </p>
                    </section>

                    <section className="space-y-3">
                        <h2 className="text-xl font-bold text-foreground">5. Contact Us</h2>
                        <p>
                            For any questions regarding refunds or cancellations, please reach out to us at freshomeatapp@gmail.com or call +91 95372-68055.
                        </p>
                    </section>
                </div>
            </div>
        </motion.div>
    );
};

export default function RefundPolicyPage() {
    return (
        <Suspense fallback={<div className="flex items-center justify-center min-h-[50vh]">
            <div className="w-8 h-8 border-4 border-primary border-t-transparent rounded-full animate-spin" />
        </div>}>
            <RefundPolicyContent />
        </Suspense>
    );
}
